import { createFileRoute } from "@tanstack/react-router";
import { Bot } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { ApiClients } from "@/features/agents/modules/api-clients/api-clients";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/agents/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.agents_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={Bot} title={m.agents_title()} description={m.agents_description()}>
      <ApiClients />
    </PageShell>
  );
}
